export const telephoneLocaleCodes = [
  { label: '+1', value: '+1' },
  { label: '+20', value: '+20' },
  { label: '+212', value: '+212' },
  { label: '+213', value: '+213' },
  { label: '+216', value: '+216' },
  { label: '+218', value: '+218' },
  { label: '+221', value: '+221' },
  { label: '+224', value: '+224' },
  { label: '+225', value: '+225' },
  { label: '+226', value: '+226' },
  { label: '+229', value: '+229' },
  { label: '+231', value: '+231' },
  { label: '+233', value: '+233' },
  { label: '+234', value: '+234' },
  { label: '+235', value: '+235' },
  { label: '+236', value: '+236' },
  { label: '+237', value: '+237' },
  { label: '+238', value: '+238' },
  { label: '+240', value: '+240' },
  { label: '+241', value: '+241' },
  { label: '+244', value: '+244' },
  { label: '+246', value: '+246' },
  { label: '+249', value: '+249' },
  { label: '+251', value: '+251' },
  { label: '+253', value: '+253' },
  { label: '+254', value: '+254' },
  { label: '+255', value: '+255' },
  { label: '+256', value: '+256' },
  { label: '+257', value: '+257' },
  { label: '+261', value: '+261' },
  { label: '+265', value: '+265' },
  { label: '+269', value: '+269' },
  { label: '+27', value: '+27' },
  { label: '+291', value: '+291' },
  { label: '+298', value: '+298' },
  { label: '+299', value: '+299' },
  { label: '+30', value: '+30' },
  { label: '+31', value: '+31' },
  { label: '+32', value: '+32' },
  { label: '+33', value: '+33' },
  { label: '+34', value: '+34' },
  { label: '+350', value: '+350' },
  { label: '+351', value: '+351' },
  { label: '+352', value: '+352' },
  { label: '+353', value: '+353' },
  { label: '+354', value: '+354' },
  { label: '+355', value: '+355' },
  { label: '+356', value: '+356' },
  { label: '+357', value: '+357' },
  { label: '+358', value: '+358' },
  { label: '+359', value: '+359' },
  { label: '+36', value: '+36' },
  { label: '+370', value: '+370' },
  { label: '+371', value: '+371' },
  { label: '+372', value: '+372' },
  { label: '+375', value: '+375' },
  { label: '+376', value: '+376' },
  { label: '+377', value: '+377' },
  { label: '+380', value: '+380' },
  { label: '+381', value: '+381' },
  { label: '+385', value: '+385' },
  { label: '+386', value: '+386' },
  { label: '+387', value: '+387' },
  { label: '+39', value: '+39' },
  { label: '+40', value: '+40' },
  { label: '+41', value: '+41' },
  { label: '+420', value: '+420' },
  { label: '+421', value: '+421' },
  { label: '+423', value: '+423' },
  { label: '+43', value: '+43' },
  { label: '+44', value: '+44' },
  { label: '+45', value: '+45' },
  { label: '+46', value: '+46' },
  { label: '+47', value: '+47' },
  { label: '+48', value: '+48' },
  { label: '+49', value: '+49' },
  { label: '+501', value: '+501' },
  { label: '+502', value: '+502' },
  { label: '+503', value: '+503' },
  { label: '+504', value: '+504' },
  { label: '+506', value: '+506' },
  { label: '+507', value: '+507' },
  { label: '+509', value: '+509' },
  { label: '+51', value: '+51' },
  { label: '+52', value: '+52' },
  { label: '+53', value: '+53' },
  { label: '+54', value: '+54' },
  { label: '+55', value: '+55' },
  { label: '+56', value: '+56' },
  { label: '+57', value: '+57' },
  { label: '+58', value: '+58' },
  { label: '+591', value: '+591' },
  { label: '+592', value: '+592' },
  { label: '+593', value: '+593' },
  { label: '+594', value: '+594' },
  { label: '+598', value: '+598' },
  { label: '+60', value: '+60' },
  { label: '+61', value: '+61' },
  { label: '+62', value: '+62' },
  { label: '+63', value: '+63' },
  { label: '+64', value: '+64' },
  { label: '+65', value: '+65' },
  { label: '+66', value: '+66' },
  { label: '+679', value: '+679' },
  { label: '+689', value: '+689' },
  { label: '+81', value: '+81' },
  { label: '+82', value: '+82' },
  { label: '+84', value: '+84' },
  { label: '+850', value: '+850' },
  { label: '+852', value: '+852' },
  { label: '+853', value: '+853' },
  { label: '+855', value: '+855' },
  { label: '+856', value: '+856' },
  { label: '+86', value: '+86' },
  { label: '+880', value: '+880' },
  { label: '+886', value: '+886' },
  { label: '+90', value: '+90' },
  { label: '+91', value: '+91' },
  { label: '+92', value: '+92' },
  { label: '+93', value: '+93' },
  { label: '+94', value: '+94' },
  { label: '+95', value: '+95' },
  { label: '+960', value: '+960' },
  { label: '+962', value: '+962' },
  { label: '+963', value: '+963' },
  { label: '+964', value: '+964' },
  { label: '+965', value: '+965' },
  { label: '+966', value: '+966' },
  { label: '+967', value: '+967' },
  { label: '+968', value: '+968' },
  { label: '+970', value: '+970' },
  { label: '+971', value: '+971' },
  { label: '+972', value: '+972' },
  { label: '+973', value: '+973' },
  { label: '+974', value: '+974' },
  { label: '+975', value: '+975' },
  { label: '+976', value: '+976' },
  { label: '+977', value: '+977' },
  { label: '+98', value: '+98' },
  { label: '+992', value: '+992' },
  { label: '+993', value: '+993' },
  { label: '+994', value: '+994' },
  { label: '+996', value: '+996' },
  { label: '+998', value: '+998' },
];
//NOTE THIS LIST NEEDS TO HAVE 155 ENTRIES FOR ALL COUNTRIES - Missing around 50-60 countries

// export const internationalTelephoneCodes = [
//  { label: '+1', value: '+1', country: 'United States', countryCodeAlpha3: 'USA' },
//   { label: '+44', value: '+44', country: 'United Kingdom', countryCodeAlpha3: 'GBR' },
//   { label: '+91', value: '+91', country: 'India', countryCodeAlpha3: 'IND' },
//   { label: '+61', value: '+61', country: 'Australia', countryCodeAlpha3: 'AUS' },
//   { label: '+81', value: '+81', country: 'Japan', countryCodeAlpha3: 'JPN' },
//   { label: '+49', value: '+49', country: 'Germany', countryCodeAlpha3: 'DEU' },
//   { label: '+33', value: '+33', country: 'France', countryCodeAlpha3: 'FRA' },
//   { label: '+39', value: '+39', country: 'Italy', countryCodeAlpha3: 'ITA' },
//   { label: '+86', value: '+86', country: 'China', countryCodeAlpha3: 'CHN' },
//   { label: '+7', value: '+7', country: 'Russia', countryCodeAlpha3: 'RUS' },
//   { label: '+55', value: '+55', country: 'Brazil', countryCodeAlpha3: 'BRA' },
//   { label: '+27', value: '+27', country: 'South Africa', countryCodeAlpha3: 'ZAF' },
//   { label: '+34', value: '+34', country: 'Spain', countryCodeAlpha3: 'ESP' },
//   { label: '+64', value: '+64', country: 'New Zealand', countryCodeAlpha3: 'NZL' },
//   { label: '+52', value: '+52', country: 'Mexico', countryCodeAlpha3: 'MEX' },
//   { label: '+82', value: '+82', country: 'South Korea', countryCodeAlpha3: 'KOR' },
//   { label: '+46', value: '+46', country: 'Sweden', countryCodeAlpha3: 'SWE' },
//   { label: '+47', value: '+47', country: 'Norway', countryCodeAlpha3: 'NOR' },
//   { label: '+31', value: '+31', country: 'Netherlands', countryCodeAlpha3: 'NLD' },
//   { label: '+41', value: '+41', country: 'Switzerland', countryCodeAlpha3: 'CHE' },
//   { label: '+32', value: '+32', country: 'Belgium', countryCodeAlpha3: 'BEL' },
//   { label: '+48', value: '+48', country: 'Poland', countryCodeAlpha3: 'POL' },
//   { label: '+351', value: '+351', country: 'Portugal', countryCodeAlpha3: 'PRT' },
//   { label: '+420', value: '+420', country: 'Czech Republic', countryCodeAlpha3: 'CZE' },
//   { label: '+43', value: '+43', country: 'Austria', countryCodeAlpha3: 'AUT' },
//   { label: '+65', value: '+65', country: 'Singapore', countryCodeAlpha3: 'SGP' },
//   { label: '+66', value: '+66', country: 'Thailand', countryCodeAlpha3: 'THA' },
//   { label: '+90', value: '+90', country: 'Turkey', countryCodeAlpha3: 'TUR' },
//   { label: '+62', value: '+62', country: 'Indonesia', countryCodeAlpha3: 'IDN' },
//   { label: '+63', value: '+63', country: 'Philippines', countryCodeAlpha3: 'PHL' },
//   { label: '+60', value: '+60', country: 'Malaysia', countryCodeAlpha3: 'MYS' },
//   { label: '+353', value: '+353', country: 'Ireland', countryCodeAlpha3: 'IRL' },
//   { label: '+358', value: '+358', country: 'Finland', countryCodeAlpha3: 'FIN' },
//   { label: '+421', value: '+421', country: 'Slovakia', countryCodeAlpha3: 'SVK' },
//   { label: '+386', value: '+386', country: 'Slovenia', countryCodeAlpha3: 'SVN' },
//   { label: '+372', value: '+372', country: 'Estonia', countryCodeAlpha3: 'EST' },
//   { label: '+371', value: '+371', country: 'Latvia', countryCodeAlpha3: 'LVA' },
//   { label: '+370', value: '+370', country: 'Lithuania', countryCodeAlpha3: 'LTU' },
//   { label: '+40', value: '+40', country: 'Romania', countryCodeAlpha3: 'ROU' },
//   { label: '+30', value: '+30', country: 'Greece', countryCodeAlpha3: 'GRC' },
//   { label: '+357', value: '+357', country: 'Cyprus', countryCodeAlpha3: 'CYP' },
//   { label: '+356', value: '+356', country: 'Malta', countryCodeAlpha3: 'MLT' },
//   { label: '+212', value: '+212', country: 'Morocco', countryCodeAlpha3: 'MAR' },
//   { label: '+213', value: '+213', country: 'Algeria', countryCodeAlpha3: 'DZA' },
//   { label: '+216', value: '+216', country: 'Tunisia', countryCodeAlpha3: 'TUN' },
//   { label: '+20', value: '+20', country: 'Egypt', countryCodeAlpha3: 'EGY' },
//   { label: '+254', value: '+254', country: 'Kenya', countryCodeAlpha3: 'KEN' },
//   { label: '+256', value: '+256', country: 'Uganda', countryCodeAlpha3: 'UGA' },
//   { label: '+255', value: '+255', country: 'Tanzania', countryCodeAlpha3: 'TZA' },
//   { label: '+234', value: '+234', country: 'Nigeria', countryCodeAlpha3: 'NGA' },
//   { label: '+233', value: '+233', country: 'Ghana', countryCodeAlpha3: 'GHA' },
//   { label: '+27', value: '+27', country: 'South Africa', countryCodeAlpha3: 'ZAF' },
//   { label: '+211', value: '+211', country: 'South Sudan', countryCodeAlpha3: 'SSD' },
//   { label: '+251', value: '+251', country: 'Ethiopia', countryCodeAlpha3: 'ETH' },
//   { label: '+263', value: '+263', country: 'Zimbabwe', countryCodeAlpha3: 'ZWE' },
//   { label: '+260', value: '+260', country: 'Zambia', countryCodeAlpha3: 'ZMB' },
//   { label: '+258', value: '+258', country: 'Mozambique', countryCodeAlpha3: 'MOZ' },
//   { label: '+267', value: '+267', country: 'Botswana', countryCodeAlpha3: 'BWA' },
//   { label: '+268', value: '+268', country: 'Eswatini', countryCodeAlpha3: 'SWZ' },
//   { label: '+264', value: '+264', country: 'Namibia', countryCodeAlpha3: 'NAM' },
//   { label: '+265', value: '+265', country: 'Malawi', countryCodeAlpha3: 'MWI' },
//   { label: '+266', value: '+266', country: 'Lesotho', countryCodeAlpha3: 'LSO' },
//   { label: '+250', value: '+250', country: 'Rwanda', countryCodeAlpha3: 'RWA' },
//   { label: '+257', value: '+257', country: 'Burundi', countryCodeAlpha3: 'BDI' },
//   {
//     label: '+243',
//     value: '+243',
//     country: 'Democratic Republic of the Congo',
//     countryCodeAlpha3: 'COD',
//   },
//   { label: '+242', value: '+242', country: 'Republic of the Congo', countryCodeAlpha3: 'COG' },
//   { label: '+241', value: '+241', country: 'Gabon', countryCodeAlpha3: 'GAB' },
//   { label: '+240', value: '+240', country: 'Equatorial Guinea', countryCodeAlpha3: 'GNQ' },
//   { label: '+239', value: '+239', country: 'Sao Tome and Principe', countryCodeAlpha3: 'STP' },
//   { label: '+238', value: '+238', country: 'Cape Verde', countryCodeAlpha3: 'CPV' },
//   { label: '+237', value: '+237', country: 'Cameroon', countryCodeAlpha3: 'CMR' },
//   { label: '+236', value: '+236', country: 'Central African Republic', countryCodeAlpha3: 'CAF' },
//   { label: '+235', value: '+235', country: 'Chad', countryCodeAlpha3: 'TCD' },
//   { label: '+232', value: '+232', country: 'Sierra Leone', countryCodeAlpha3: 'SLE' },
//   { label: '+231', value: '+231', country: 'Liberia', countryCodeAlpha3: 'LBR' },
//   { label: '+230', value: '+230', country: 'Mauritius', countryCodeAlpha3: 'MUS' },
//   { label: '+229', value: '+229', country: 'Benin', countryCodeAlpha3: 'BEN' },
//   { label: '+228', value: '+228', country: 'Togo', countryCodeAlpha3: 'TGO' },
//   { label: '+227', value: '+227', country: 'Niger', countryCodeAlpha3: 'NER' },
//   { label: '+226', value: '+226', country: 'Burkina Faso', countryCodeAlpha3: 'BFA' },
//   { label: '+225', value: '+225', country: 'Ivory Coast', countryCodeAlpha3: 'CIV' },
//   { label: '+224', value: '+224', country: 'Guinea', countryCodeAlpha3: 'GIN' },
//   { label: '+223', value: '+223', country: 'Mali', countryCodeAlpha3: 'MLI' },
//   { label: '+222', value: '+222', country: 'Mauritania', countryCodeAlpha3: 'MRT' },
//   { label: '+221', value: '+221', country: 'Senegal', countryCodeAlpha3: 'SEN' },
//   { label: '+220', value: '+220', country: 'Gambia', countryCodeAlpha3: 'GMB' },
// ];
